//nome = codigo no BD
export const enum ETipoUsuario {
  'MRN' = 1,
  'Fornecedor' = 2,
  'Terceiro' = 3,
  'FornecedorSas' = 4,
}
